import { render, staticRenderFns } from "./ViewPractice.vue?vue&type=template&id=57f7f7f8&scoped=true"
import script from "./ViewPractice.vue?vue&type=script&lang=js"
export * from "./ViewPractice.vue?vue&type=script&lang=js"
import style0 from "./ViewPractice.vue?vue&type=style&index=0&id=57f7f7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7f7f8",
  null
  
)

export default component.exports